// Per-category accent colors for the Vault storefront (row accents + category
// chip). Reuses the same hue palette already established per-mechanic across
// the main Star Shop page (gold/blue/rose/violet/emerald/amber/cyan/lime/pink
// — see Index.vue's RowShell `:accent` props), extended with three more hues
// (teal/indigo/red) to cover all 12 StarShopVaultVideoCategoryEnum cases.
const VAULT_CATEGORY_COLORS = {
    'Behind the Scenes': '#FDBA74',
    "Director's Cut": '#FCD34D',
    'Exclusive Clips': '#FB7185',
    'Extended Cuts': '#4D94FF',
    'Alternate Angles': '#C4B5FD',
    'Unreleased Footage': '#34D399',
    'Deleted Scenes': '#67E8F9',
    'Candid Set Footage': '#A3E635',
    'Performer Interviews': '#F9A8D4',
    'Archive Extras': '#2DD4BF',
    'Remastered or Restored Material': '#818CF8',
    'Vertical and short-form exclusives': '#F87171',
}

const DEFAULT_COLOR = '#FDBA74'

export function getCategoryColor(category) {
    return VAULT_CATEGORY_COLORS[category] || DEFAULT_COLOR
}

export default VAULT_CATEGORY_COLORS
